// @flow
import { useDispatch, useSelector } from "react-redux";
import {
  startProgress,
  finishProgress,
  resetProgress,
  updateProgress,
} from "../redux/actions/ProgressIndicator";
import type { ProgressIndicatorState } from "../redux/types";
import { useCallback } from "react";

type ProgressIndicatorHook = {
  start: () => void,
  finish: () => void,
  reset: () => void,
  update: (percentComplete: number) => void,
};

type ProgressIndicatorStateHook = {
  ...ProgressIndicatorState,
};

/**
 */
export const useProgressIndicator = (): ProgressIndicatorHook => {
  const dispatch = useDispatch();

  const start = useCallback(() => {
    dispatch(startProgress());
  }, [dispatch]);
  const finish = useCallback(() => {
    dispatch(finishProgress());
  }, [dispatch]);
  const reset = useCallback(() => {
    dispatch(resetProgress());
  }, [dispatch]);
  const update = useCallback(
    (percentComplete: number) => {
      dispatch(updateProgress(percentComplete));
    },
    [dispatch],
  );

  return { start, finish, reset, update };
};

/**
 */
export const useProgressIndicatorState = (): ProgressIndicatorStateHook =>
  useSelector((state) => state.progressindicator);
